import { getItem, removeItem } from '@repo/utils';
import { jwtDecode } from 'jwt-decode';

import type { VuexAuth } from './schema';
import { IdTokenSchema, VuexAuthSchema } from './schema';

export const authLocalStorageKey = 'vuex';

function parseVuexStore(value: string): VuexAuth {
  const vuexStore = JSON.parse(value);
  return VuexAuthSchema.parse(vuexStore);
}

export async function getTokens() {
  let token;
  const vuexStore = getItem(authLocalStorageKey);
  if (vuexStore) {
    token = parseVuexStore(vuexStore).auth;
  }
  return token;
}

export function removeToken() {
  removeItem(authLocalStorageKey);
}

export async function parseIdToken(token: string) {
  const parsedToken = jwtDecode(token);
  return IdTokenSchema.parse(parsedToken);
}
